import React from "react";
import { Button, Container, TextField, InputLabel, Select, MenuItem } from "@material-ui/core";
import VolumeSlider from "hearing/assets/signal-loss/volume-slider";
import {P1, P2, P3} from 'assets/fonts';


class VolumeAdjustment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      volumeAdjuest: false,
      audio: new Audio(process.env.PUBLIC_URL + "/hearing/functional-audio/adjust.wav"),
      audioPlay: false,
      audioVolume: 0,
      output: null,
      aids: null,
    };
  }
  componentDidMount = () => {
    const { audio, audioVolume } = this.state;
    audio.volume = audioVolume;
  };

  componentDidUpdate = () => {
    const { audio, audioVolume } = this.state;
    audio.volume = audioVolume;
  };

  handlePlay = async () => {
    const { audio } = this.state;
    await audio.play();
    this.setState({ audioPlay: true });
  };

  handleStop = async () => {
    const { audio } = this.state;
    await audio.pause();
    this.setState({ audioPlay: false });
  };

  handleVolume = (volume) => {
    this.setState({ audioVolume: volume / 100 });
  };

  handleChangeOutput = (e) => {
    this.setState({ output: e.target.value });
  }

  handleAidsChange = (e) => {
    this.setState({ aids: e.target.value });
  }

  renderButton = () => {
    const { output, aids, audioVolume } = this.state;
    if (!!output && aids != null && !!audioVolume) {
      return <Button
        variant="contained"
        style={{ margin: 20, width: 150, color: "white", backgroundColor: "#107896" }}
        onClick={() => {
          this.state.audio.pause();
          this.props.handleClick(output, aids, audioVolume)
        }}
      >
        Next
    </Button>
    } else {
      return <div><Button
        variant="contained"
        disabled
        style={{ margin: 20, width: 150, color: "white", backgroundColor: "#107896" }}
      >
        Next
    </Button>
    <P3>You cannot progress to the next step because you have not completed the questions.</P3>
    </div>
    }
  }

  render() {
    const { audioPlay, output, aids } = this.state;
    return (
      <Container>
        <div
          style={{
            textAlign: "left",
            position: "relative",
            marginTop: "10%",
          }}
        >
          <Container>
            <div id="source">
              <P2>You can use either speakers or headphones to complete this experiment. Headphones will work best. </P2>
              <P2>Using the dropbox below, select what you will be using to complete this experiment.</P2>
              {
                output === "speakers" ?
                <P2>(If using speakers, please keep a consistent distance from your computer during the entire
                  experiment)</P2> : null
              }
              <Select
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                value={output}
                onChange={this.handleChangeOutput}
                style={{ width: 150 }}
              >
                <MenuItem value="headphones">headphones</MenuItem>
                <MenuItem value="speakers">speakers</MenuItem>
              </Select>
            </div>
            <br />
            <div id="aids">
              <P2>Will you be wearing amplification (e.g., hearing aid(s), cochlear implant(s), bone anchored hearing aid(s), etc.) when you complete this experiment?</P2>
              <Select
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                value={aids}
                onChange={this.handleAidsChange}
                style={{ width: 150 }}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </div>
            <br />
            <div>
              <P2>
                Please set your computer volume to approximately 50%. Click PLAY to listen to an audio sample.
            </P2>
              <P2>
                Move the slider bar to your most comfortable listening level. Once comfortable, click NEXT to begin the study.
            </P2>
            <P2>Please do not adjust your computer volume during the experiment. </P2>
            </div>
            <VolumeSlider
              handleVolume={this.handleVolume}
              style={{ marginLeft: 5 }}
            />
          </Container>
          <br />
          {audioPlay ? (
            <Button
              variant="contained"
              onClick={this.handleStop}
              style={{ marginLeft: "20px", width: 150, color: "white", backgroundColor: "#107896" }}
            >
              Stop
            </Button>
          ) : (
              <Button
                variant="contained"
                onClick={this.handlePlay}
                style={{
                  marginLeft: "20px",
                  width: 150,
                  color: "white", backgroundColor: "#107896"
                }}
              >
                Play
              </Button>
            )}
            <br />
          {this.renderButton()}
        </div>
      </Container>
    );
  }
}

export default VolumeAdjustment;
